import { Link } from "react-router-dom";
import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { Icon } from "./home/components/Icon";
import { SectionHeading } from "./home/components/SectionHeading";
import { FaqSection } from "./home/sections/FaqSection";
import { DownloadSection } from "./home/sections/DownloadSection";
import { RichText, useSiteTranslation } from "./home/i18n";
import "./home/styles/why.css";
import "./safety.css";

const GUIDELINE_ICONS = ["check", "heart", "shield"];

export default function SafetyComponent() {
  const { t } = useSiteTranslation();
  const guidelines = t("safety.guidelines", { returnObjects: true });

  return (
    <SiteLayout title={t("safety.title")}>
      <PageHero eyebrow={t("safety.eyebrow")} title={<RichText k="safety.heading" />} lead={t("safety.lead")}>
        <div className="safety-hero-actions">
          <Link className="safety-button" to="/contactus">
            {t("safety.contactSupport")} <Icon name="arrow" />
          </Link>
          <Link className="safety-text-link" to="/communityguidelines">
            {t("safety.readGuidelines")}
          </Link>
        </div>
      </PageHero>

      <section className="section why" id="guidelines">
        <div className="wrap">
          <SectionHeading
            layout="split"
            eyebrow={t("safety.guidelinesEyebrow")}
            title={<RichText k="safety.guidelinesTitle" />}
            lead={t("safety.guidelinesLead")}
          />
          <div className="pillar-grid">
            {guidelines.map(({ title, text }, index) => (
              <article key={title} className="pillar" data-reveal style={{ "--delay": `${index * 0.08}s` }}>
                <span>
                  <Icon name={GUIDELINE_ICONS[index]} />
                </span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="safety-alert">
        <div className="wrap safety-alert-row" data-reveal>
          <span className="safety-alert-icon">
            <Icon name="shield" />
          </span>
          <div>
            <h2>{t("safety.unsafeTitle")}</h2>
            <p>{t("safety.unsafeText")}</p>
          </div>
          <Link className="safety-button light" to="/contactus">
            {t("safety.contactSupport")} <Icon name="arrow" />
          </Link>
        </div>
      </section>

      <FaqSection
        items={t("help.faqs", { returnObjects: true })}
        id="questions"
        eyebrow={t("safety.faqEyebrow")}
        title={t("safety.faqTitle")}
        lead={t("safety.faqLead")}
      />

      <DownloadSection />
    </SiteLayout>
  );
}
